import { Action } from '@reduxjs/toolkit';
import { Epic, combineEpics } from 'redux-observable';
import { filter, from, ignoreElements, map, switchMap } from 'rxjs';

import actions from './session.actions';
import * as sessionAPI from './session.api';

import { notNull } from 'utils/type_guards';
import reporter from 'utils/reporter';
import { catchAndLogError } from 'utils/common';

import type { CheckoutRootState } from 'store/checkout_store';
import type { RootState } from 'store/wos_store';

export const getSessionEpic: Epic<Action, Action, RootState | CheckoutRootState> = (action$) =>
  action$.pipe(
    filter(actions.getSession.pending.match),
    switchMap(() =>
      from(sessionAPI.get()).pipe(
        map((session) => actions.getSession.fulfilled(session)),
        catchAndLogError(actions.getSession.rejected)
      )
    )
  );

export const addSentryUserEpic: Epic<Action> = (action$) =>
  action$.pipe(
    filter(actions.getSession.fulfilled.match),
    filter(({ payload }) => notNull(payload.customer_num)),
    map(({ payload }) => {
      reporter.setUser({
        email: payload.customer_email,
        id: payload.customer_num.toString(),
        username: payload.customer_num.toString(),
      });
    }),
    ignoreElements()
  );

const combined = combineEpics(getSessionEpic, addSentryUserEpic);

export default combined;
